import { createReducer } from '@reduxjs/toolkit'

import { DATES, AGGREGATION } from 'const/filters'
import { LOCAL_FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'

import {
    defaultResourcePageTabs,
    defaultResourcePageWidgets,
    defaultResourcePage,
} from '../defaults'

const defaultState = {
    [LOCAL_FILTERS]: {},
    [FILTER_SETTINGS]: {
        anchored: [DATES, AGGREGATION],
        order: [],
        displayState: {},
    },

    ...defaultResourcePage,

    tabs: defaultResourcePageTabs,
    widgets: defaultResourcePageWidgets('keywordPage'),
}

export default createReducer(defaultState, () => {})
